module.exports = __webpack_public_path__ + "assets/img/jiachib_3013_2.8891113d.jpg";